import { Avatar, Group, Menu, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconUserCircle } from '@tabler/icons-react';
import { useAuth, uniqueRoles } from '../auth/AuthProvider';

/**
 * Header user-menü: avatar + név + chevron, kattintásra dropdown.
 * Tartalom:
 *  - aktív role kiválasztása (ha a user-nek több role-ja van)
 *  - kilépés (most placeholder, az auth bekötésekor él)
 */
export function UserMenu() {
  const { user, roles, activeRole, setActiveRole } = useAuth();
  if (!user) return null;

  const distinctRoles = uniqueRoles(roles);

  return (
    <Menu shadow="md" width={240} position="bottom-end">
      <Menu.Target>
        <UnstyledButton>
          <Group gap="xs">
            <Avatar size="sm" radius="xl" color="teal">
              <IconUserCircle size={20} />
            </Avatar>
            <div style={{ lineHeight: 1.1 }}>
              <Text size="sm" fw={500}>
                {user.displayName}
              </Text>
              {activeRole && (
                <Text size="xs" c="dimmed">
                  {activeRole}
                </Text>
              )}
            </div>
            <IconChevronDown size={14} />
          </Group>
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        {distinctRoles.length > 1 && (
          <>
            <Menu.Label>Aktív szerep</Menu.Label>
            {distinctRoles.map((r) => (
              <Menu.Item
                key={r}
                onClick={() => setActiveRole(r)}
                disabled={r === activeRole}
              >
                {r}
              </Menu.Item>
            ))}
            <Menu.Divider />
          </>
        )}
        <Menu.Item disabled>Kilépés (hamarosan)</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
